export default __webpack_public_path__ + "static/media/356EBC_27_0.cd95a831.woff";